import styled from 'styled-components';
import { Spinner } from './spinner.tsx';

export function ModalSpinner() {
  return (
    <BackGround>
      <Spinner />
    </BackGround>
  );
}

const BackGround = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  background-color: var(--color-background-modal-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
`;
